import { Addon } from '@domain/addon';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventAddons = async (eventId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/add-ons?limit=100`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetAddons = ({ eventId, enabled }: { eventId: string; enabled?: boolean }) => {
  return useGenericQuery<Addon[], RequestError>(['get-event-addons'], () => getEventAddons(eventId), {
    enabled: enabled ?? !!eventId,
  });
};
